const formatPhoneNum = (data) => {
  if(data) {
    if (!data.startsWith("001")) {
      return `001${data.replace(/[().\s-]+/g, '').replace(/^\+1/, '').replace(/^\+/, '1')}`;
    } else {
      return data.replace(/[().\s-]+/g, '').replace(/^\+1/, '').replace(/^\+/, '1');
    }
  }
  return null;
};


const designateShopifyId = (url) => {
  const suffix =
    url === 'https://olukai.com' ? 'us' :
    url === 'https://vip.olukai.com' ? 'vip' :
    url === 'https://olukai.ca' ? 'ca' :
    '';

  return suffix ? "shopify_id_" + suffix : null;
};

//Function call template: 
// exponeaTrack.doubleOptIn({
//   shop_url: '{{ shop.url }}', 
//   shopify_id: '{{ customer.id }}', 
//   opt_in_type: 'email', 
//   email: '<EMAIL>', 
//   phone: '<PHONE>', 
//   source: '<SOURCE>', 
//   marketing_signup: true, 
//   loyalty_signup: false
// });
const exponeaTrack = {
  doubleOptIn: ({shop_url, shopify_id, opt_in_type, email, phone, source, marketing_signup, loyalty_signup}) => {
    if(email) {
      email = email.toLowerCase();
    }

    // console.log('Double Opt-In Event:', JSON.stringify({
    //   shop_url,
    //   shopify_id,
    //   opt_in_type,
    //   email,
    //   phone: formatPhoneNum(phone),
    //   source,
    //   marketing_signup,
    //   loyalty_signup,
    //   ...(designateShopifyId(shop_url) && { [designateShopifyId(shop_url)]: shopify_id })
    // }));

    // Identify the customer in Exponea
    exponea.identify({ 
      ...(email && { email_id: email }),
      ...(phone && { phone_id: formatPhoneNum(phone) })
    });

    // Update the customer's email and/or phone in Exponea
    // If a shopify ID exists for the customer, grab the current shop name as the key and add the customer's ID to the update.
    exponea.update({
      ...(email && { email: email }),
      ...(phone && { phone: formatPhoneNum(phone) }),
      ...(designateShopifyId(shop_url) && { [designateShopifyId(shop_url)]: shopify_id })
    });

    // Track the double opt-in event in Exponea
    exponea.track('double_opt_in', {
      action: 'new',
      opt_in_type: opt_in_type,
      ...(email && { email: email }),
      ...(phone && { phone: formatPhoneNum(phone) }),
      source: source,
      ...(designateShopifyId(shop_url) && { [designateShopifyId(shop_url)]: shopify_id }),
      marketing_signup: marketing_signup,
      loyalty_signup: loyalty_signup
    });
  },
  ohanaProgram: ({first_name, last_name, email, phone, possible_gender, marketing_signup, loyalty_signup}) => {

    if(email) {
      email = email.toLowerCase();
    }
    // Identify the customer in Exponea
    exponea.identify({ 
      ...(email && { email_id: email }),
      ...(phone && { phone_id: formatPhoneNum(phone) })
    });

    // Update the customer's email and/or phone in Exponea
    exponea.update({
      first_name,
      last_name,
      ...(email && { email: email }),
      ...(phone && { phone: formatPhoneNum(phone) }),
      possible_gender
    });

    // Track the double opt-in event in Exponea
    exponea.track('ohana_program', {
      first_name,
      last_name,
      ...(email && { email: email }),
      ...(phone && { phone: formatPhoneNum(phone) }),
      possible_gender,
      marketing_signup: marketing_signup,
      loyalty_signup: loyalty_signup
    });
  },
}
window.exponeaTrack = exponeaTrack
window.addEventListener('DOMContentLoaded', exponeaTrack.init)
